import { STATUS_DOT_COLOR, type StatusColor } from "@/lib/status-colors";
import { cn } from "@/lib/utils";

// The one status label every page renders through — domain-agnostic (takes
// a resolved label/color, not an enum or a domain name; `lib/status-colors.ts`
// maps a domain enum value onto a `StatusColor`). Tinted pill: a soft
// background tint at the status color plus solid-color text — same
// alpha-hex-over-token technique `stat-card.tsx`'s icon accent already uses
// (`${hex}1A` background), just applied to a text chip instead of an icon
// tile. Rounded-full to match this app's existing pill vocabulary
// (`period-switcher.tsx`, `TabNav`). Uppercase via CSS `text-transform`, not
// a string transform, so it displays consistently regardless of what case
// the caller's label is in — pass `className="normal-case"` for the rare
// caller (e.g. a raw free-text value) that wants the label's own casing.

export function StatusBadge({
  label,
  color,
  subLabel,
  className,
}: {
  label: string;
  color: StatusColor;
  subLabel?: string | null;
  className?: string;
}) {
  const hex = STATUS_DOT_COLOR[color];

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide",
        className,
      )}
      style={{ backgroundColor: `${hex}1A`, color: hex }}
    >
      {label}
      {subLabel ? ` · ${subLabel}` : ""}
    </span>
  );
}
